<mat-dialog-content>
    <p [innerHTML]="infoText"></p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button [mat-dialog-close]="true" mat-flat-button color="primary" id="close">{{'Close' | translate}}</button>
</mat-dialog-actions>
